module.exports = __webpack_public_path__ + "static/media/candidat_heureux_i.fcfcc146.jpg";